export enum ClassificationOperatorType {
  EQUAL = "EQUAL" as any,
  NOT_EQUAL = "NOT_EQUAL" as any,
}
